import { fetchApi } from '@vend/utilities'
import { ApiTransaction } from '@vend/types'
import { SwiperError, SwiperErrorResponse } from './lspay.types'

export type ConfirmPaymentStateResponse = {
  status: string
  transaction?: ApiTransaction
}

export const confirmPaymentState = async (
  registerId: string,
  registerSalePaymentId: string,
  paymentId: string,
  customerId?: string,
  retailerPaymentTypeId?: string
): Promise<ConfirmPaymentStateResponse> => {
  // Build query parameters
  const queryParams = new URLSearchParams({
    payment_id: paymentId,
  })

  if (customerId) {
    queryParams.append('customer_id', customerId)
  }

  if (retailerPaymentTypeId) {
    queryParams.append('retailer_payment_type_id', retailerPaymentTypeId)
  }

  const response = await fetchApi(
    `/api/2.0/lspay/registers/${registerId}/transactions/${registerSalePaymentId}?${queryParams.toString()}`,
    {
      method: 'GET',
    }
  )

  if (!response.ok) {
    const swiperError: SwiperErrorResponse = await response.json()

    throw new SwiperError(
      swiperError.error,
      swiperError.code,
      swiperError.fields
    )
  }
  const data = await response.json()
  return {
    status: data.status,
    transaction: data.transaction,
  }
}
